















import { defineComponent, useRoute } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import { trackLogoClick } from '~/helpers/trackings/layout';
import { ISTITUTIONAL_SITE } from '~/utils/constants/store';
import { PAYWALL_LINKS, PAYWALL_SCRIPTS, PAYWALL_TITLE } from '~/utils/constants/nuxt/metaInfos';
import ClientOnly from 'vue-client-only'

export default defineComponent({
  components: {
    PageLoading,
    ClientOnly
  },
  head() {
    return {
      htmlAttrs: {
        lang: 'it'
      },
      title: PAYWALL_TITLE,
      script: PAYWALL_SCRIPTS,
      link: PAYWALL_LINKS
    }
  },
  setup() {
    const route = useRoute();
    const logoLink = ISTITUTIONAL_SITE;
    return { 
        route,
        addBasePath,
        logoLink,
      trackLogoClick,
    };
  },
  methods: {
    goToLink() {
      window.location.href = this.logoLink;
    },
  },
});
